import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, Button, ComponentSync, LL_H_C, LL_V_L, openContent, stopPropagation } from '@nu-art/thunderstorm-frontend/index';
import { filterInstances, groupArrayBy, sortArray } from '@nu-art/ts-common';
import './Component_MetaPathwayOrder.scss';
import { ModuleFE_EMInterface, ModuleFE_RuntimeOrder } from '@app/advisor-frontend';
import { Loader_OrderButton } from '../../../panels/AdvisorPanel_NextSteps/Renderer_Order/Loader_OrderButton.js';
import { ProtocolData } from '../../../../_utils/ProtocolData/ProtocolData.js';
import { ICONS } from '@app/styles';
const rejectTooltipId = 'metapathway-order-reject-tooltip';
const noColorConst = '###NOCOLOR###';
export class Component_MetaPathwayOrder extends ComponentSync {
    //######################### Life Cycle #########################
    __onReadOnlyChanged = () => {
        this.setState({ disabled: this.isDisabled(this.state) });
    };
    deriveStateFromProps(nextProps, state) {
        state.protocolData = filterInstances(nextProps.relatedProtocols.map(protocol => ProtocolData.createNew(protocol._id)));
        //As a base, start off the order as disabled if the advisor is in read only mode, this may be overwritten in child implementations of deriveStateFromProps
        state.disabled = nextProps.disabled || ModuleFE_EMInterface.isReadonly();
        state.className = nextProps.className;
        return state;
    }
    //######################### Logic #########################
    getClassName() {
        return _className('component-meta-pathway-order', this.state.className, this.state.disabled && 'disabled');
    }
    rejectOrder = async (e) => {
        stopPropagation(e);
        const rtOrderIds = this.getRuntimeOrderIds();
        await ModuleFE_RuntimeOrder.rejectRuntimeOrders(rtOrderIds);
    };
    isDisabled(state = this.state) {
        return state.disabled;
    }
    getVariant() {
        return 'metapathway-order__base';
    }
    handleOnClick = async (e) => {
        if (this.props.rejected)
            return;
        stopPropagation(e);
        await this.props.onClickPreAction?.();
        await this.onClick(e);
        await this.props.onClickPostAction?.();
    };
    onContextMenu;
    //######################### Render #########################
    render() {
        return _jsxs(Button, { className: this.getClassName(), onClick: this.handleOnClick, onContextMenu: this.onContextMenu, variant: this.getVariant(), loader: Loader_OrderButton, disabled: this.isDisabled(), children: [this.render_Icon(), this.render_Label(), this.render_Protocols()] });
    }
    render_Icon = () => {
        return _jsx("div", { className: 'component-meta-pathway-order__icon', children: this.getIcon() });
    };
    render_Label = () => {
        return _jsx("div", { className: 'component-meta-pathway-order__label', children: this.getLabel() });
    };
    render_Protocols = () => {
        const protocolGroups = groupArrayBy(this.state.protocolData, data => data.getColor() ?? noColorConst);
        return _jsxs(LL_H_C, { className: 'component-meta-pathway-order__protocols', children: [protocolGroups.map(group => {
                    const color = group.key === noColorConst ? undefined : group.key;
                    const style = {};
                    if (color) //@ts-ignore - can set custom css rules
                        style['--dp-color'] = color;
                    const labels = (sortArray(group.values, v => v.pathway.label)).map(data => _jsx("div", { children: data.pathway.label }, data.pathway._id));
                    return _jsx("div", { className: 'component-meta-pathway-order__protocols__protocol', style: style, ...openContent.tooltip.top('tooltip__related-protocols', _jsx(LL_V_L, { id: 'related-protocol-labels', children: labels })) }, group.key);
                }), this.render_RejectButton()] });
    };
    render_RejectButton = () => {
        if (this.props.rejected)
            return;
        return _jsx("div", { className: 'component-meta-pathway-order__reject-btn', onClick: this.rejectOrder, ...openContent.tooltip.top(rejectTooltipId, 'Remove from suggestions', { offset: 8 }), children: _jsx(ICONS.advisor_avn_close.component, {}) });
    };
}
//# sourceMappingURL=Component_MetaPathwayOrder.js.map